import { useState, useMemo } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';

import { formatNumber } from 'utils';

import NoneToDisplay from './NoneToDisplay';
import NewSimulationButton from './NewSimulationButton';

export const Totals = ({ data }) => {

    const columnNames = {
        'Emissions Factor': 'Emissions Factor (%)',
        'Total Methane Emitted': 'Total Methane Emitted (kg)',
        'Total Methane Left in Slurry': 'Total Methane Left in Slurry (kg)',
        // Add more mappings as needed
    };


    const [sortColumn, setSortColumn] = useState('date_empty');
    const [sortDirection, setSortDirection] = useState('asc');

    const handleSort = (column) => {
        if (sortColumn === column) {
            // Toggle sort direction
            setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
      };    


    const sorted_data = useMemo(() => {
        return [...data].sort((a, b) => {
            const isDateField = sortColumn === 'date_empty'
            const aValue = isDateField ? new Date(a[sortColumn]) : a.model_totals?.[sortColumn];
            const bValue = isDateField ? new Date(b[sortColumn]) : b.model_totals?.[sortColumn];

            if (aValue === undefined || bValue === undefined) return 0;

            if (sortDirection === 'asc') {
                return aValue > bValue ? 1 : -1;
            } else {
                return aValue < bValue ? 1 : -1;
            }
        });
    }, [data, sortColumn, sortDirection]);

    const totals = sorted_data[0]?.model_totals || {}
    const tableExists = Object.values(totals).length > 0
    const columns = tableExists ? Object.keys(totals) : []

    const TableSortableColumn = ({ children, column }) => {
        return(
            <TableCell>
                <TableSortLabel
                    active={sortColumn === column}
                    direction={sortDirection}
                    onClick={() => handleSort(column)}
                >
                    <strong>{children}</strong>
                </TableSortLabel>
            </TableCell>
        )
    }
   
    return tableExists ? (
        <>
            <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableSortableColumn column={'date_empty'}>
                                Empty Date
                            </TableSortableColumn>
                            {columns.map((column) => (
                                <TableSortableColumn key={column} column={column}>
                                    {columnNames[column] || column}
                                </TableSortableColumn>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sorted_data.map(({ run_id, date_empty, model_totals }) => (
                            <TableRow key={run_id}>
                                <TableCell>{new Date(date_empty).toLocaleDateString('en-GB')}</TableCell>
                                {columns.map(column => {
                                const value = model_totals[column];
                                return (
                                    <TableCell key={column}>
                                    {value != null
                                        ? formatNumber(
                                            column === 'Emissions Factor' ? value * 100 : value,
                                            { maxDecimal: 1 }
                                        )
                                        : '-'}
                                    </TableCell>
                                );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <NewSimulationButton />
        </>
    ) : <NoneToDisplay object='totals' />
  };
  